var _defs, _rect, _rect2, _rect3, _rect4, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBra(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Rainbow_inline",
    "data-name": "Rainbow inline",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1564.491 398.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_168",
    "data-name": "Rectangle 168",
    width: 1564.491,
    height: 398.82,
    fill: "none"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_164",
    "data-name": "Rectangle 164",
    width: 1564.475,
    height: 99.703,
    transform: "translate(0.013 0)",
    fill: "#71427b"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_165",
    "data-name": "Rectangle 165",
    width: 1564.475,
    height: 99.705,
    transform: "translate(0.013 99.704)",
    fill: "#f63"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_166",
    "data-name": "Rectangle 166",
    width: 1564.475,
    height: 99.705,
    transform: "translate(0.008 199.41)",
    fill: "#0ac2a7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_167",
    "data-name": "Rectangle 167",
    width: 1564.477,
    height: 99.704,
    transform: "translate(0.002 299.116)",
    fill: "#06f"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_478",
    "data-name": "Group 478"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_477",
    "data-name": "Group 477",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_786",
    "data-name": "Path 786",
    d: "M404.512,277.012V243.344h1.063c7.8,21.973,28.725,37.21,61.7,37.21,49.292,0,76.6-35.792,76.6-91.076S518,98.4,470.116,98.4c-33.688,0-55.32,17.722-63.123,36.855V39.577H381.454V277.012Zm2.481-72.294V174.6c0-36.147,21.277-54.208,56.032-54.208,34.043,0,55.32,15.592,55.32,69.1s-20.932,69.093-55.334,69.093c-34.741,0-56.018-18.074-56.018-53.867m217.736,75.838c33.336,0,55.675-15.947,65.959-36.145l1.771.353v32.249h23.052v-109.5c0-38.983-21.275-69.1-68.087-69.1-45.392,0-73.407,29.058-73.407,65.56V166.8h24.47v-5.316c0-28,14.894-40.4,46.807-40.4,32.98,0,46.1,12.4,46.1,43.236v12.77l-61.7,8.507c-38.311,5.316-60.983,18.782-60.983,49.254-.01,29.4,24.1,45.7,56.02,45.7ZM593.52,233.068c0-18.782,10.284-24.454,38.309-28.35l59.578-8.5v6.024c0,41.463-29.435,57.055-59.578,57.055-26.958,0-38.309-8.152-38.309-26.224m186.526,43.944v-101c0-38.983,18.8-55.284,53.549-55.284,35.814,0,48.227,16.657,48.227,54.574V277.01H907V169.638c0-42.171-20.567-71.231-65.6-71.231-36.169,0-56.03,21.265-62.768,39.693H777.57V101.946H754.518V277.01Zm191.138,0V198.339h43.974l51.773,78.673h29.788l-60.984-92.139,62.411-82.923h-29.788l-53.2,73.353H971.187V39.577H945.648V277.012Z",
    transform: "translate(379.203 39.343)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_787",
    "data-name": "Path 787",
    d: "M219.424,276.889V229.1H96.837V39.705H43.7V276.889Zm98.843,3.54c51.017,0,83.611-22.3,83.611-60.182v-3.54H349.443v2.128c0,10.968-9.211,15.576-30.468,15.576-29.05,0-38.971-9.913-40.034-34.7H401.168a160.284,160.284,0,0,0,2.481-26.194c0-46.375-31.531-78.234-85.026-78.234-55.621,0-89.633,36.109-89.633,93.1,0,56.287,27.987,92.042,89.278,92.042m-1.418-141.6c24.8,0,36.845,10.266,35.782,28.675H279.3c2.126-18.762,12.044-28.675,37.553-28.675m162.97,141.6c32.948,0,51.017-14.515,60.583-27.612h2.116v24.073h49.254V171.4c0-47.438-27.634-76.111-80.067-76.111-50.307,0-83.256,27.967-83.256,70.447v3.894h50.656v-3.9c0-18.055,8.5-24.073,30.111-24.073,20.9,0,32.239,3.894,32.239,24.781V172.1l-60.928,9.2c-36.845,5.663-56.684,22.657-56.684,50.269,0,32.213,24.446,48.851,55.976,48.851m-5.314-53.1c0-7.434,4.959-10.968,15.943-12.744l51.017-7.789c0,27.612-22.32,33.276-43.93,33.276-15.59,0-23.03-3.185-23.03-12.742",
    transform: "translate(43.442 39.471)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBra);
export default __webpack_public_path__ + "static/media/BRA.ac3c1cd4616dbd6b8c15437a5b1c0e02.svg";
export { ForwardRef as ReactComponent };